export default __webpack_public_path__ + "static/ZUaCzWXN-cd7c6d90ca57baa88d917e812102c9e1.svg";